import { Col, View } from "@amzn/stencil-react-components/layout";
import { H2 } from "@amzn/stencil-react-components/text";
import React, { FC } from "react";
import type { MyHardwareDevice } from "@/services/my-hardware/my-hardware.types";
import { DeviceRow, RowEmphasis } from "@/pages/MyHardware/components/DeviceRow/device-row";
import { AssetActionKind } from "@/pages/MyHardware/my-hardware.types";

interface DeviceGroupProps {
  heading: string;
  devices: MyHardwareDevice[];
  isActionable: boolean;
  onAction: (device: MyHardwareDevice, action: AssetActionKind) => void;
  dataTestId: string;
}

const emphasisFor = (isActionable: boolean, index: number): RowEmphasis => {
  if (!isActionable) return "tertiary";
  return index === 0 ? "primary" : "secondary";
};

export const DeviceGroup: FC<DeviceGroupProps> = ({
  heading,
  devices,
  isActionable,
  onAction,
  dataTestId,
}) => {
  if (devices.length === 0) {
    return null;
  }

  return (
    <Col gridGap="S300" width="100%" data-testid={dataTestId}>
      <H2 fontSize="T300" color="neutral90">
        {heading}
      </H2>
      <View
        width="100%"
        backgroundColor="neutral0"
        border="1px solid var(--st-dt-color-neutral-20)"
        borderRadius="var(--st-dt-dimensions-border-radius-200)"
        overflow="hidden"
      >
        {devices.map((device, index) => (
          <DeviceRow
            key={device.assetId}
            device={device}
            hasDivider={index > 0}
            emphasis={emphasisFor(isActionable, index)}
            onAction={onAction}
          />
        ))}
      </View>
    </Col>
  );
};
